var productFormSelector = 'form[action*="cart/add"].product-buy-form-pdp';

function Elixir_ProductFormExists() {
    return document.querySelector(productFormSelector) !== null;
}

function Elixir_GetProductForm() {
    return document.querySelector(productFormSelector);
}

function Elixir_ProductFormHasItemsInputs() {
    var form = Elixir_GetProductForm();
    if (!form) return false;
    return form.querySelector('input[name^="items["]') !== null;
}

// Returns the variant ID from the product form. In single-variant mode uses input[name="id"]; in items[] mode (e.g. Quantity Break) uses the first items[X][id] value so price/context use the correct variant.
function Elixir_GetProductFormVariantId() {
    var form = Elixir_GetProductForm();
    if (!form) return null;
    var input = form.querySelector('input[name="id"]');
    if (input && input.value) return input.value;
    if (Elixir_ProductFormHasItemsInputs()) {
        var firstId = form.querySelector('input[name^="items["][name*="][id]"]');
        if (firstId && firstId.value) return firstId.value;
    }
    return null;
}

// Returns the selling plan ID from the product form (input[name="selling_plan"]), or null if missing/empty.
function Elixir_GetProductFormSellingPlan() {
    var form = Elixir_GetProductForm();
    if (!form) return null;
    var input = form.querySelector('input[name="selling_plan"]');
    return input && input.value ? input.value : null;
}

// Writes a value to a form input and announces it, but only when it is genuinely new.
//
// Rewriting the value an input already holds is not a change, and saying otherwise is how
// the form ends up in a feedback loop: plenty of listeners react to a variant or plan change
// by recomputing state and writing the id straight back, so an unconditional dispatch lets
// them re-enter through their own change handlers and cascade. The DOM is still kept in sync
// either way; all that is skipped is the notification.
function _writeProductFormInput(input, value) {
    var unchanged = input.value === value && input.getAttribute('value') === value;
    input.value = value;
    input.setAttribute('value', value);
    if (unchanged) return false;
    input.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
    input.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
    return true;
}

// Sets the selling plan on the product form. Creates input[name="selling_plan"] if missing.
// Pass null, undefined or '' to clear (one-time purchase). Dispatches input and change events
// only when the plan actually differs from the one already on the form.
function Elixir_SetProductFormSellingPlan(sellingPlanId) {
    var form = Elixir_GetProductForm();
    if (!form) return false;
    var value = (sellingPlanId !== undefined && sellingPlanId !== null && sellingPlanId !== '') ? String(sellingPlanId) : '';
    var input = form.querySelector('input[name="selling_plan"]');
    if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        form.appendChild(input);
    }
    _writeProductFormInput(input, value);
    return true;
}

// Sets the main variant id on the product form. Creates the input[name="id"] if missing.
// Pass null/undefined/'' to clear. Dispatches input + change events (bubbling) on the resolved
// input, matching Elixir_SetProductFormSellingPlan, so callers don't need to dispatch manually.
// Setting the id the form already carries is silent, see _writeProductFormInput.
function Elixir_SetProductFormVariantId(variantId) {
    var form = Elixir_GetProductForm();
    if (!form) return false;
    var value = (variantId !== undefined && variantId !== null && variantId !== '') ? String(variantId) : '';
    var input = form.querySelector('input[name="id"]');
    if (!input) {
        if (value === '') return true;
        if (form.querySelector('.quantity-break-variant-form input[name^="items["]')) return false;
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'id';
        input.className = 'product-variant-id';
        form.appendChild(input);
    }
    _writeProductFormInput(input, value);
    return true;
}

function Elixir_ProductFormSwitchToItemsMode(items, options) {
    var form = Elixir_GetProductForm();
    if (!form) return false;
    if (!items || !Array.isArray(items) || items.length === 0) return false;

    options = options || {};
    var containerClass = options.containerClass || 'product-form-items-container';
    var startIndex = options.startIndex !== undefined ? options.startIndex : 1;

    var existing = form.querySelector('.' + containerClass);
    if (existing) existing.remove();

    var container = document.createElement('div');
    container.className = containerClass;

    items.forEach(function (item, i) {
        var index = startIndex + i;
        var idIn = document.createElement('input');
        idIn.type = 'hidden';
        idIn.name = 'items[' + index + '][id]';
        idIn.value = String(item.id);
        idIn.className = 'product-variant-id';
        container.appendChild(idIn);

        var qtyIn = document.createElement('input');
        qtyIn.type = 'hidden';
        qtyIn.name = 'items[' + index + '][quantity]';
        qtyIn.value = String(item.quantity != null ? item.quantity : 1);
        container.appendChild(qtyIn);

        if (item.selling_plan != null && item.selling_plan !== '') {
            var planIn = document.createElement('input');
            planIn.type = 'hidden';
            planIn.name = 'items[' + index + '][selling_plan]';
            planIn.value = String(item.selling_plan);
            container.appendChild(planIn);
        }

        if (item.properties && typeof item.properties === 'object') {
            Object.keys(item.properties).forEach(function (key) {
                var propIn = document.createElement('input');
                propIn.type = 'hidden';
                propIn.name = 'items[' + index + '][properties][' + key + ']';
                propIn.value = String(item.properties[key]);
                container.appendChild(propIn);
            });
        }
    });

    var mainIdInput = form.querySelector('input[name="id"]');
    if (mainIdInput) mainIdInput.remove();

    form.appendChild(container);
    Elixir_SyncDynamicCheckoutVisibility();
    return true;
}

function Elixir_SyncDynamicCheckoutVisibility() {
    var form = Elixir_GetProductForm();
    if (!form) return;
    var wrapper = form.querySelector('.shopify-payment-button');
    if (!wrapper) return;
    var itemsMode = form.querySelector('input[name^="items["]') !== null;
    wrapper.style.display = itemsMode ? 'none' : '';
    wrapper.hidden = itemsMode;
}

function Elixir_ProductFormSwitchToSingleIdMode(variantId, itemsContainerSelector) {
    var form = Elixir_GetProductForm();
    if (!form) return false;

    if (itemsContainerSelector) {
        var container = form.querySelector(itemsContainerSelector);
        if (container && (variantId === undefined || variantId === null || variantId === '')) {
            var firstIdInput = container.querySelector('input[name^="items["][name*="][id]"]');
            if (firstIdInput && firstIdInput.value) variantId = firstIdInput.value;
        }
        if (container) container.remove();
    }

    var input = form.querySelector('input[name="id"]');
    if (input) {
        if (variantId !== undefined && variantId !== null && variantId !== '') input.value = String(variantId);
        Elixir_SyncDynamicCheckoutVisibility();
        return true;
    }
    if (variantId === undefined || variantId === null || variantId === '') {
        Elixir_SyncDynamicCheckoutVisibility();
        return true;
    }

    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'id';
    input.value = String(variantId);
    input.className = 'product-variant-id';
    form.appendChild(input);
    Elixir_SyncDynamicCheckoutVisibility();
    return true;
}


// Returns the next available items[] index across the entire product form.
// Scans all items[N][...] inputs and returns max(N) + 1, or 0 if none exist.
// Used by upsell bulk helpers to avoid index collisions with quantity break items.
function Elixir_GetNextFormItemIndex() {
	var form = Elixir_GetProductForm();
	if (!form) return 0;
	var max = -1;
	form.querySelectorAll('input[name^="items["]').forEach(function(inp) {
		var m = inp.name.match(/^items\[(\d+)\]/);
		if (m) {
			var n = parseInt(m[1], 10);
			if (n > max) max = n;
		}
	});
	return max + 1;
}

// Registers a bulk upsell variant in the product form DOM so it is submitted
// alongside the main product when the PDP form is submitted. Idempotent —
// calling with the same variantId twice is a no-op.
function Elixir_UpsellBulkAdd(variantId) {
	var form = Elixir_GetProductForm();
	if (!form) return false;
	var containerClass = 'upsell-bulk-items-container';
	var container = form.querySelector('.' + containerClass);
	if (!container) {
		container = document.createElement('div');
		container.className = containerClass;
		form.appendChild(container);
	}
	// Guard against duplicates
	if (container.querySelector('input[data-upsell-variant="' + variantId + '"]')) return true;
	var idx = Elixir_GetNextFormItemIndex();
	var idIn = document.createElement('input');
	idIn.type = 'hidden';
	idIn.name = 'items[' + idx + '][id]';
	idIn.value = String(variantId);
	idIn.setAttribute('data-upsell-variant', String(variantId));
	container.appendChild(idIn);
	var qtyIn = document.createElement('input');
	qtyIn.type = 'hidden';
	qtyIn.name = 'items[' + idx + '][quantity]';
	qtyIn.value = '1';
	container.appendChild(qtyIn);
	return true;
}

// Removes a previously staged bulk upsell variant from the product form DOM.
// Re-indexes remaining upsell entries so indices stay contiguous and above
// any non-upsell items[] already in the form.
function Elixir_UpsellBulkRemove(variantId) {
	var form = Elixir_GetProductForm();
	if (!form) return false;
	var container = form.querySelector('.upsell-bulk-items-container');
	if (!container) return true;
	var idInput = container.querySelector('input[data-upsell-variant="' + variantId + '"]');
	if (idInput) {
		var m = idInput.name.match(/^items\[(\d+)\]/);
		if (m) {
			var qtyInput = container.querySelector('input[name="items[' + m[1] + '][quantity]"]');
			if (qtyInput) qtyInput.remove();
		}
		idInput.remove();
	}
	// Determine the lowest safe index: max index used by non-upsell items[] + 1
	var nonUpsellMax = -1;
	form.querySelectorAll('input[name^="items["]').forEach(function(inp) {
		if (container.contains(inp)) return;
		var m2 = inp.name.match(/^items\[(\d+)\]/);
		if (m2) {
			var n = parseInt(m2[1], 10);
			if (n > nonUpsellMax) nonUpsellMax = n;
		}
	});
	// Re-index remaining upsell entries
	var remaining = container.querySelectorAll('input[data-upsell-variant]');
	remaining.forEach(function(el, i) {
		var newIdx = nonUpsellMax + 1 + i;
		var oldM = el.name.match(/^items\[(\d+)\]/);
		var qtyIn = oldM ? container.querySelector('input[name="items[' + oldM[1] + '][quantity]"]') : null;
		el.name = 'items[' + newIdx + '][id]';
		if (qtyIn) qtyIn.name = 'items[' + newIdx + '][quantity]';
	});
	return true;
}

function Elixir_ProductFormMergeFreeGiftsIntoItems(unlockedGiftVariantIds) {
    unlockedGiftVariantIds = unlockedGiftVariantIds || [];
    var form = Elixir_GetProductForm();
    if (!form) return false;

    var startIndex = document.querySelectorAll('.product-variant-premium-kit').length + 1;
    var qbContainer = form.querySelector('.quantity-break-variant-form');
    var hasQuantityBreakUi = !!document.querySelector('.quantity-break-option, .quantity-break-option-container');

    function lineHasFreeItemFlag(n) {
        var marker = form.querySelector('input[name="items[' + n + '][properties][_free_item]"]');
        return !!(marker && String(marker.value) !== '');
    }

    function collectBaseItemsFromQbContainer(container) {
        var list = [];
        for (var n = 1; n < 50; n++) {
            var idIn = form.querySelector('input[name="items[' + n + '][id]"]');
            if (!idIn || !idIn.value || !container.contains(idIn)) continue;
            if (lineHasFreeItemFlag(n)) continue;
            var qtyIn = form.querySelector('input[name="items[' + n + '][quantity]"]');
            var planIn = form.querySelector('input[name="items[' + n + '][selling_plan]"]');
            var item = { id: idIn.value, quantity: qtyIn ? (parseInt(qtyIn.value, 10) || 1) : 1 };
            if (planIn && planIn.value) item.selling_plan = planIn.value;
            var props = {};
            form.querySelectorAll('input[name^="items[' + n + '][properties]"]').forEach(function (inp) {
                var m = inp.name.match(/^items\[\d+\]\[properties\]\[([^\]]+)\]$/);
                if (m && m[1] !== '_free_item') props[m[1]] = inp.value;
            });
            if (Object.keys(props).length) item.properties = props;
            list.push(item);
        }
        return list;
    }

    var baseItems = [];
    if (qbContainer) {
        baseItems = collectBaseItemsFromQbContainer(qbContainer);
    }
    if (baseItems.length === 0) {
        var sid = form.querySelector('input[name="id"]');
        if (sid && sid.value && !sid.disabled) {
            var q = form.querySelector('input[name="quantity"]');
            if (!q && form.getAttribute('id')) {
                q = document.querySelector('input[name="quantity"][form="' + form.getAttribute('id') + '"]');
            }
            var one = { id: sid.value, quantity: q ? (parseInt(q.value, 10) || 1) : 1 };
            var spl = form.querySelector('input[name="selling_plan"]');
            if (spl && spl.value) one.selling_plan = spl.value;
            baseItems = [one];
        }
    }

    if (baseItems.length === 0) return false;

    var hadFreeItemMarkers = !!form.querySelector('input[name*="[properties][_free_item]"]');

    var giftLines = unlockedGiftVariantIds.map(function (vid) {
        return { id: String(vid), quantity: 1, properties: { _free_item: '1' } };
    });

    if (giftLines.length === 0) {
        if (!hadFreeItemMarkers) return true;
        if (hasQuantityBreakUi) {
            return Elixir_ProductFormSwitchToItemsMode(baseItems, {
                containerClass: 'quantity-break-variant-form',
                startIndex: startIndex
            });
        }
        Elixir_ProductFormSwitchToSingleIdMode(baseItems[0].id, '.quantity-break-variant-form');
        var qin = form.querySelector('input[name="quantity"]');
        if (!qin && form.getAttribute('id')) {
            qin = document.querySelector('input[name="quantity"][form="' + form.getAttribute('id') + '"]');
        }
        if (qin) qin.value = String(baseItems[0].quantity);
        if (baseItems[0].selling_plan) Elixir_SetProductFormSellingPlan(baseItems[0].selling_plan);
        return true;
    }

    var merged = baseItems.concat(giftLines);
    return Elixir_ProductFormSwitchToItemsMode(merged, {
        containerClass: 'quantity-break-variant-form',
        startIndex: startIndex
    });
}

function Elixir_InitProductFormQuantityListener() {
    document.addEventListener('change', function (e) {
        if (!e.target || e.target.name !== 'quantity') return;
        var form = Elixir_GetProductForm();
        if (!form) return;
        var belongsToForm = form.contains(e.target) ||
            (form.getAttribute('id') && e.target.getAttribute('form') === form.getAttribute('id'));
        if (!belongsToForm) return;
        var qty = parseInt(e.target.value, 10);
        if (isNaN(qty) || qty < 1) qty = 1;
        Elixir_SetProductFormQuantity(qty, { source: 'quantity-input' });
    });
}
Elixir_InitProductFormQuantityListener();

function Elixir_SetProductFormQuantity(quantity, options) {
	var form = Elixir_GetProductForm();
	if (!form) return false;
	var qty = parseInt(quantity, 10);
	if (isNaN(qty) || qty < 1) qty = 1;
	var source = (options && options.source) || null;

	// 1. Keep / create the in-form hidden quantity input (the cart form authority).
	var input = form.querySelector('input[type="hidden"][name="quantity"]');
	if (!input) {
		input = document.createElement('input');
		input.type = 'hidden';
		input.name = 'quantity';
		form.appendChild(input);
	}
	input.value = String(qty);
	input.setAttribute('value', String(qty));

	// 2. Sync every external input linked to this form via the `form` attribute so
	//    quantity selector UIs (stepper / dropdown) stay in step without needing
	//    to listen to the raw quantity input change event themselves.
	if (form.getAttribute('id')) {
		document.querySelectorAll('input[name="quantity"][form="' + form.getAttribute('id') + '"]').forEach(function (ext) {
			if (ext !== input) {
				ext.value = String(qty);
				ext.setAttribute('value', String(qty));
				// Do NOT dispatch change here — the quantity:changed event below is the
				// canonical broadcast; individual selectors react to that.
			}
		});
	}

	// 3. Always dispatch quantity:changed with the source so every consumer
	//    can determine whether it originated the change and skip its own echo.
	document.dispatchEvent(new CustomEvent('quantity:changed', {
		bubbles: true,
		detail: { quantity: qty, source: source }
	}));

	return true;
}

function Elixir_InitQuantityBundleFallback(root) {
	if (!root || root.__elixirQuantityBundleFallbackBound) return;
	root.__elixirQuantityBundleFallbackBound = true;

	function getCards() {
		return root.querySelectorAll('.quantity-bundle-card');
	}

	function selectCard(card, skipQuantitySync) {
		if (!card) return;
		var cards = getCards();
		for (var i = 0; i < cards.length; i++) {
			var currentCard = cards[i];
			currentCard.setAttribute('data-selected', currentCard === card ? 'true' : 'false');
			var currentRadio = currentCard.querySelector('.quantity-bundle-radio');
			if (currentRadio) currentRadio.checked = currentCard === card;
		}
		if (skipQuantitySync) return;
		var quantity = parseInt(card.getAttribute('data-quantity'), 10);
		if (!isNaN(quantity) && quantity > 0) {
			Elixir_SetProductFormQuantity(quantity);
		}
	}

	root.addEventListener('click', function (event) {
		if (!event.target || typeof event.target.closest !== 'function') return;
		var card = event.target.closest('.quantity-bundle-card');
		if (!card || !root.contains(card)) return;
		selectCard(card, false);
	});

	root.addEventListener('change', function (event) {
		var target = event.target;
		if (!target || !target.classList || !target.classList.contains('quantity-bundle-radio')) return;
		if (typeof target.closest !== 'function') return;
		var card = target.closest('.quantity-bundle-card');
		if (!card || !root.contains(card)) return;
		selectCard(card, false);
	});

	var initiallySelectedCard = root.querySelector('.quantity-bundle-card[data-selected="true"]') || root.querySelector('.quantity-bundle-card');
	if (initiallySelectedCard) {
		selectCard(initiallySelectedCard, true);
	}
}

function Elixir_BindQuantityBundleFallbacks(scope) {
	var searchRoot = scope && scope.querySelectorAll ? scope : document;
	var bundleRoots = searchRoot.querySelectorAll('.quantity-bundle-selector');
	for (var i = 0; i < bundleRoots.length; i++) {
		Elixir_InitQuantityBundleFallback(bundleRoots[i]);
	}
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', function () {
		Elixir_BindQuantityBundleFallbacks(document);
	});
} else {
	setTimeout(function () {
		Elixir_BindQuantityBundleFallbacks(document);
	}, 0);
}

document.addEventListener('shopify:section:load', function (event) {
	Elixir_BindQuantityBundleFallbacks(event && event.target ? event.target : document);
});
